module.exports = __webpack_public_path__ + "img/decorate_logo_pc.png";